module.exports = __webpack_public_path__ + "static/CircuPay_Logo-184bbb84b4e971948466044b4725211d.png";